import React, { useState, useEffect } from 'react';
import CarouselComponentBasic from './carousel-basic';
import PhotosInterface from 'interfaces/photo.interface';

const Carousel: React.FC<{
    photos: PhotosInterface[];
    alt: string;
    title: string;
    emulateTouch: boolean;
    onClick?: () => void;
    modalCarousel?: boolean;
    showThumbs: boolean;
    className?: string;
    showStatus?: boolean;
    showArrows?: boolean;
}> = props => {
    const [CarouselComponent, setCarousel] = useState<React.ComponentType<any>>(() => CarouselComponentBasic);

    useEffect(() => {
        import('react-responsive-carousel-2').then(mod => {
            setCarousel(() => mod.Carousel);
        });
    }, []);

    return (
        <CarouselComponent
            showArrows={props.showArrows}
            showStatus={props.showStatus || false}
            statusFormatter={(current: number, total: number): string => `${current}/${total}`}
            emulateTouch={props.emulateTouch}
            showThumbs={props.showThumbs}
            showIndicators={false}
            className={props.className || ''}
        >
            {
                props.photos.map((item: PhotosInterface, index: number) => (
                    <div
                        key={item.thumb}
                        onClick={props.onClick}
                        className={`slide__content slide__content${props.modalCarousel ? '--big' : '--small gtm_gp_open'}`}
                    >
                        <img
                            src={props.modalCarousel ? item.large : item.thumb}
                            alt={props.alt}
                            title={props.title}
                            height={props.modalCarousel ? '' : 200}
                            className={`slide__content__image slide__content__image${props.modalCarousel ? '--big' : '--small'}`}
                            loading={(index === 0) ? 'eager' : 'lazy'}
                        />
                    </div>
                ))
            }
        </CarouselComponent>
    );
};

export default Carousel;
